import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Fade, Zoom } from "@mui/material";
import OrderDetailsSection from "./components/OrderDetailsSection";
import ThermalPrinterTest from "src/printConfigration/PrintConfigration";
import { useOrderDetails } from "./hooks/useOrderDetails";
import { useCurrentTime } from "./hooks/useCurrentTime";
import api from "src/features/auth/axiosConfig";
import PaymentDetailsSection from "./components/PaymentDetailsSection";
import { PageTitle } from "src/shared/PageTitle";
import LoadingScreen from "src/shared/components/LoadingScreen";
import useResPrintData from "./useResPrintData";

const Respayment = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { time } = useCurrentTime();
  const [tip, setTip] = useState(0);
  const [customTip, setCustomTip] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [showPrint, setShowPrint] = useState(false);

  const { order, setOrder, loading } = useOrderDetails(id);

  // Use the custom hook for print data
  const printData = useResPrintData(order);

  useEffect(() => {
    document.title = "Payment › iMetanic";
  }, []);

  const guess = order?.guess ? parseInt(order.guess) || 0 : 0;
  const total = (Number(order?.Finalamount) || 0) + tip;

  const handleCustomTipChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCustomTip(value);
    setTip(Number(value));
  };

  const handleTipChange = (amount: number) => {
    setTip(amount);
    setCustomTip("");
  };

  const handlePayNow = async () => {
    if (!order) return;

    setIsProcessing(true);
    const paymentupdate = {
      OrderStatus: "Completed",
      Orderdate: order.Orderdate,
      Ordertime: order.Ordertime,
      DeliveryDate: `${time.year}-${time.month}-${time.day}`,
      DeliveryTime: `${time.hours}:${time.minutes}`,
      Paymenttime: `${time.hours}:${time.minutes}`,
      payments: [{ Paymentmethod: paymentMethod, ReceivedAmount: total }],
      paymentHistory: [{ Paymentmethod: paymentMethod, ReceivedAmount: total }],
      Tip: tip,
      id: order?.Customerid,
      RemainingAmount: 0,
      discount: order.discount,
      Finalamount: order.Finalamount,
      new_order_amount: 0,
      outstanding_balance: Number(order.Finalamount),
    };

    try {
      await api.patch(`/app/v1/pos/order/${id}`, paymentupdate);
      toast.success("Payment completed successfully!");

      // Update local state immediately
      setOrder((prevOrder) =>
        prevOrder
          ? {
              ...prevOrder,
              payments: [{ Paymentmethod: paymentMethod, ReceivedAmount: total }],
              paymentHistory: [{ Paymentmethod: paymentMethod, ReceivedAmount: total }],
              Tip: tip,
              OrderStatus: "Completed",
              PaymentStatus: "Paid",
              Paymenttime: `${time.hours}:${time.minutes}`,
            }
          : null,
      );

      // Show print component and trigger print
      setShowPrint(true);
      setTimeout(() => {
        // window.print();
        setTimeout(() => {
          navigate("/v1/Reshome");
        }, 1000);
      }, 500);
    } catch (error) {
      console.error(error);
      toast.error("Failed to complete payment");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className='flex flex-col h-[91.5vh] overflow-hidden bg-gradient-to-br from-blue-50 to-indigo-100'>
      <PageTitle title='- Payment' />
      <Fade in={!loading} timeout={500}>
        <div className='flex flex-1 flex-col lg:flex-row p-1.5 gap-2 h-[calc(100vh-4rem)] overflow-hidden'>
          {/* Left: Order Details Section */}
          <Zoom in={!loading} style={{ transitionDelay: !loading ? "200ms" : "0ms" }}>
            <div className='w-full lg:w-2/3 h-[91vh] lg:h-[91vh] overflow-hidden rounded-2xl border border-gray-100'>
              <OrderDetailsSection order={order} />
            </div>
          </Zoom>

          {/* Right: Payment Details Section (scrollable only inside) */}
          <div className='thin-scrollbar w-full lg:w-1/3 h-full lg:h-full overflow-y-auto'>
            <PaymentDetailsSection
              order={order}
              tip={tip}
              customTip={customTip}
              paymentMethod={paymentMethod}
              guess={guess}
              total={total}
              onTipChange={handleTipChange}
              onCustomTipChange={handleCustomTipChange}
              onPayNow={handlePayNow}
              onPaymentMethodChange={setPaymentMethod}
              isProcessing={isProcessing}
            />
          </div>
        </div>
      </Fade>

      {/* Print Component - Same as Resorders */}
      {showPrint && printData && <ThermalPrinterTest PrintData={printData} isClosed={() => setShowPrint(false)} openPrint='true' />}

      <ToastContainer autoClose={2000} position='top-right' />
      {loading && <LoadingScreen />}
    </div>
  );
};

export default Respayment;
